
import {map} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { OrderAcceptDeclineService } from '../shared/order-accept-decline.service';

@Component({
    selector: 'app-orders-confirmation',
    templateUrl: './orders-confirmation.component.html',
    styleUrls: ['./orders-confirmation.component.css'],
    standalone: false
})
export class OrdersConfirmationComponent implements OnInit {

  public guid: string;
  public result: any = {};
  private apiValidateResponse: string;

  constructor(private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private orderConfirmService: OrderAcceptDeclineService) {
      this.activatedRoute.params.subscribe(params => {
        this.guid = params.guid;
      });
    }

  ngOnInit() {
    this.processRequest();
  }

  private processRequest() {
    const userToken = this.authService.getToken();
    if (!userToken || userToken === 'null' || userToken === undefined) {
      this.router.navigate([`/login/confirm/${this.guid}`]);
    } else {
      this.validateRequest(this.guid).then(() => {
        this.confirmOrder(this.guid);
      });
    }
  }

  private validateRequest(guid: string) {
    return this.orderConfirmService.validate(guid).pipe(map(response => {
       this.apiValidateResponse = 'confirm';
    })).toPromise()
      .catch(errorResponse => {
        this.apiValidateResponse = errorResponse.error;
      });
  }

  private confirmOrder(guid: string) {
    if (this.apiValidateResponse === 'confirm') {
      this.orderConfirmService.confirmOrder(guid).subscribe(response => {
      this.createSuccessResult(response.result);
      this.orderConfirmService.redirectAfterProcessing(this.result);
      },
      errorResponse => {
      this.createInvalidResult('ORDER-CONFIRM-REJECT.CONFIRM-FAIL-MESSAGE');
      this.orderConfirmService.redirectAfterProcessing(this.result);
      });
    } else {
      this.createInvalidResult(this.apiValidateResponse);
      this.orderConfirmService.redirectAfterProcessing(this.result);
    }
  }

  private createSuccessResult(orderIds: number[]) {
    this.result.ordersIds = orderIds.length > 0 ? orderIds.join(', ') : null;
    this.result.message = 'ORDER-CONFIRM-REJECT.CONFIRM-SUCCESS-MESSAGE';
  }

  private createInvalidResult(translateKey: string) {
    this.result.ordersIds = null;
    this.result.message = translateKey;
  }
}
